import { render, staticRenderFns } from "./WoTerm.vue?vue&type=template&id=b37d245c"
import script from "./WoTerm.vue?vue&type=script&lang=js"
export * from "./WoTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports